export const VIEW_HEIGHT = 600
